import { FC } from 'react'
import { Text } from '../../text/textStyles'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    display: flex;
    flex-direction: column;
`

const LabelContainer = styled.div`
    display: flex;
    justify-content: space-between;
`

const Label = styled(Text)`
    text-transform: capitalize;
`

export interface LabelProps {
    label?: string
    supportingLabel?: string
    description?: string
}

export const InputLabels: FC<LabelProps> = ({
    label,
    supportingLabel,
    description,
}) => {
    return (
        <Container>
            <LabelContainer>
                <Label size="medium" $weight="bold" color="none">
                    {label}
                </Label>
                <Text size="small" $weight="regular">
                    {supportingLabel}
                </Text>
            </LabelContainer>

            <Text size="small" $weight="regular" color="none">
                {description}
            </Text>
        </Container>
    )
}
